import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-[432px] h-[56px]" }
const _hoisted_2 = {
  key: 0,
  class: "footer h-[56px] bg-System/app_white"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1)
const _hoisted_4 = { class: "h-full flex items-center" }
const _hoisted_5 = { class: "absolute right-[24px]" }
const _hoisted_6 = { class: "flex items-center flex-nowrap" }
const _hoisted_7 = {
  key: 0,
  class: "infinite-spinner-animation rounded-[50%] border-2 border-solid border-white border-b-transparent mr-[8px] !w-[16px] !h-[16px]"
}

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';
import DisableStepTwo from '@/components/common/dialogs/settingsActiveDirectoryDialog/disableStepTwo.vue';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'formFooter',
  props: {
    isActivateLoading: { type: Boolean, default: false },
    isUserEnabled: { type: Boolean, default: false },
    hideSubmitButton: { type: Boolean, default: false }
  },
  emits: ["submitForm", "deactivate"],
  setup(__props: any, { emit }: { emit: ({ (e: 'submitForm'): void; (e: 'deactivate'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { isActivateLoading: boolean, isUserEnabled: boolean, hideSubmitButton: boolean }



const showSecondStep = ref(false);


const submitButtonTitle = computed(() => {
  if (props.isActivateLoading) {
    return props.isUserEnabled ? 'Saving' : 'Connecting';
  }
  return props.isUserEnabled ? 'Save' : 'Connect';
});

const handleDeactivate = () => {
  emit('deactivate');
  showSecondStep.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "h-full relative" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!showSecondStep.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(_unref(IncrediButton), {
                  class: "grow ml-[12px]",
                  design: "ghost-red",
                  size: "small",
                  type: "submit",
                  disabled: __props.isActivateLoading,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showSecondStep.value = true), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.footer.deactivate')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]), [
                  [_vShow, __props.isUserEnabled]
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (!__props.hideSubmitButton)
                    ? (_openBlock(), _createBlock(_unref(IncrediButton), {
                        key: 0,
                        design: "primary-green",
                        size: "small",
                        disabled: __props.isActivateLoading,
                        type: "submit",
                        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (emit('submitForm')), ["prevent"]), ["enter"])),
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emit('submitForm')), ["stop","prevent"]))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            (__props.isActivateLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(_unref(submitButtonTitle)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_openBlock(), _createBlock(DisableStepTwo, {
              key: 1,
              onDeactivate: handleDeactivate,
              onHideDisableStepTwo: _cache[3] || (_cache[3] = ($event: any) => (showSecondStep.value = false))
            }))
      ])
    ]),
    _: 1
  }))
}
}

})